<template>
  <component :is="tag" class="content-headline" :class="autoClassName">
    <slot></slot>
    <template v-if="subtitle">
      <span class="content-headline-subtitle">{{ subtitle }}</span>
    </template>
  </component>
</template>
<script>

export default {
  props: [
    'content',
    'subtitle',
  ],
  data() {
    return {
      tag: this.$store.state.contentHeadlineTag,
    };
  },
  computed: {
    autoClassName() {
      const text = this.$slots.default[0].text
      return `ch-auto-${this.slugify(text)}`
    }
  },
  methods: {
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing spaces
      str = str.toLowerCase(); // convert to lowercase
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by "-"
          .replace(/-+/g, '-'); // collapse dashes
      return str;
    }
  },
}
</script>